export enum USER_ROLE {
    ADMIN = 'Admin',
    SIGN_LANGUAGE_INTERPRETER = 'Interpreter',
    ANIMATOR = 'Animator',
    CONTENT_CREATOR= 'ContentCreator'
}